import { render, staticRenderFns } from "./AssociationsViewer.vue?vue&type=template&id=0cecf357&scoped=true&lang=pug"
import script from "./AssociationsViewer.vue?vue&type=script&lang=js"
export * from "./AssociationsViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cecf357",
  null
  
)

export default component.exports